// ===================== Content registries =====================
// Weapons, elements, enemies, bosses, characters and upgrade cards register
// themselves here. The game engine only ever reads from these maps, so new
// content is added by calling the define* functions — no engine edits needed.

export const Weapons = new Map();     // id -> weapon def
export const Elements = new Map();     // id -> element def
export const EnemyDefs = new Map();    // id -> enemy def
export const BossDefs = new Map();     // id -> boss def
export const CharacterDefs = new Map();// id -> character def
export const UpgradeCards = [];        // passive/element/special cards
// Live achievement rules: { id, test(game) }. Content authors the RULE — a
// predicate over the running game — and the engine only walks the list each
// frame and fires whatever id the rule names, so game.js never names one.
export const LiveAchievements = [];

export function defineWeapon(def) {
  if (!def.id) throw new Error('weapon needs id');
  Weapons.set(def.id, def);
  return def;
}
export function defineElement(def) { Elements.set(def.id, def); return def; }
export function defineEnemy(def) { EnemyDefs.set(def.id, def); return def; }
export function defineBoss(def) { BossDefs.set(def.id, def); return def; }
export function defineCharacter(def) { CharacterDefs.set(def.id, def); return def; }
export function defineUpgrade(def) { UpgradeCards.push(def); return def; }
export function defineLiveAchievement(id, test) { LiveAchievements.push({ id, test }); return test; }

export const getWeapon = (id) => Weapons.get(id);
export const getElement = (id) => Elements.get(id);
export const getEnemy = (id) => EnemyDefs.get(id);
export const getBoss = (id) => BossDefs.get(id);
export const getCharacter = (id) => CharacterDefs.get(id);
